import React, { useEffect, useState } from "react";
import { Col, Row, Button, Modal, Form } from "react-bootstrap";
import { useHistory, NavLink } from "react-router-dom";
import { base_url, ImageUrl, Theme } from "../Helpers/request";
import "react-toastify/dist/ReactToastify.css";
import { isMobileOnly, isTablet } from "react-device-detect";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { CircularProgress, TextField } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import swal from "sweetalert";
import { cartlengthvalue } from "../Reducer/cartReducer";
import { useDispatch, useSelector } from "react-redux";
import { Wishlengthvalue } from "../Reducer/wishlistReducer";
import { loginDrawer, sessionId, Setuser } from "../Reducer/homeReducer";
import { BiUser } from "react-icons/bi";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify";
import { LazyLoadImage } from "react-lazy-load-image-component";
const Login = (props) => {
  const history = useHistory();
  const session_Id = useSelector(
    (state) => state.persistedReducer.home.session_id
  );
  const [errmsg, setErrmsg] = useState(false);
  const [errmsg2, setErrmsg2] = useState(false);
  const [msg, setMsg] = useState("");
  const [userhover, setUserhover] = useState(false);

  /*search code*/
  const [forgotpassword, setForgotpassword] = useState(false);
  //login
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const login = useSelector((state) => state.persistedReducer.home.logindrawer);
  //forgotpass
  const [f_email, setF_email] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewPass, setViewPass] = React.useState(false);
  const dispatch = useDispatch();
  const signin = () => {
    dispatch(loginDrawer(true));
    setForgotpassword(false);
  };
  const handleClicktop = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosetop = () => {
    setAnchorEl(null);
  };
  // useEffect(()=>{
  //     gapi.load('client:auth2', () => {
  //         gapi.client.init({
  //               clientId: "549981789532-4bt0u9a45fujhv35ha0dil32bomr9221.apps.googleusercontent.com",
  //               plugin_name: "chat"
  //           })
  //       })
  //   },[])

  const handlelogout = async () => {
    await dispatch(sessionId(""));
    await dispatch(loginDrawer(false));
    await dispatch(Wishlengthvalue(0));
    await dispatch(cartlengthvalue(0));
    await dispatch(Setuser([]));
    setAnchorEl(null);
    history.push("/");
  };
  const handlesubmitlogin = (e) => {
    setErrmsg(false);
    e.preventDefault();
    setButtonLoading(true);
    axios
      .post(
        base_url + "/user/login",
        { email, password, session_id: session_Id ? session_Id : "" },
        {
          headers: {
            // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.status == 1) {
          var user = {
            token: response.data.data.token,
            user_id: response.data.data.user_id,
            email: response.data.data.email,
            first_name: response.data.data.first_name,
            last_name: response.data.data.last_name,
            isLogin: true,
          };

          dispatch(cartlengthvalue(response.data.data.total_cart_count));
          dispatch(Wishlengthvalue(response.data.data.total_wish_count));
          dispatch(Setuser(user));
          dispatch(sessionId(""));
          setEmail("");
          setPassword("");
          setButtonLoading(false);
          dispatch(loginDrawer(false));
          // window.location.reload(true);
          // toast.success(response.data.message, { autoClose: 3000 });
          if (window.location.pathname == "/cart") {
            history.push("/cart");
          }else{
          history.push("/account/myaccount");
        }
        } else {
          setButtonLoading(false);
          setErrmsg(true);
          setMsg(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleforgotpassword = (e) => {
    setButtonLoading(true);
    e.preventDefault();
    var data = {
      email: f_email,
    };
    axios
      .post(base_url + "/user/forget_password", data, {
        headers: {
          // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.status == 1) {
          setButtonLoading(false);
          setF_email("");
          signin();
          return swal(response.data.message, "", "success");
        } else {
          setButtonLoading(false);
          setErrmsg2(true);
          setMsg(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const responseGoogle = (response) => {
    console.log(response);
    const data = {
      first_name: response.profileObj.givenName,
      last_name: response.profileObj.familyName,
      social_id: response.profileObj.googleId,
      login_method: 2,
      email: response.profileObj.email,
      session_id: session_Id ? session_Id : "",
      language: "EN",
      currency: "USD",
    };
    axios
      .post(`${base_url}/user/socialLogin`, data, {
        headers: {
          // 'authorization':`Token e222085edc871220cae528152b73c1317ba2addf`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.status == 1) {
          // window.location.reload(true);
          var user = {
            token: response.data.data.token,
            user_id: response.data.data.user_id,
            email: response.data.data.email,
            first_name: response.data.data.first_name,
            last_name: response.data.data.last_name,
            isLogin: true,
          };
          dispatch(cartlengthvalue(response.data.data.total_cart_count));
          dispatch(Wishlengthvalue(response.data.data.total_wish_count));
          dispatch(Setuser(user));
          dispatch(sessionId(""));
          setEmail("");
          setPassword("");
          setButtonLoading(false);
          dispatch(loginDrawer(false));
        } else {
          setButtonLoading(false);
          setErrmsg(true);
          setMsg(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [buttonLoading, setButtonLoading] = useState(false);

  const user = useSelector((state) => state.persistedReducer.home.userData);
  return (
    <>
      {user?.isLogin ? (
        <>
          <Button
            className="rcs_blank_button rcs_after_login_button "
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClicktop}
          >
            {isMobileOnly ? (
              <span className="rcs_mobile">{user?.first_name[0]}</span>
            ) : isTablet ? (
              <span className="rcs_mobile">{user?.first_name[0]}</span>
            ) : (
              <span className="rcs_mobile">
                {user?.first_name[0]} <KeyboardArrowDownIcon />
              </span>
            )}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            className="rcs_menu_list_item"
            open={Boolean(anchorEl)}
            onClick={handleClosetop}
          >
            <MenuItem disabled>
              {/* <BiUser />  */}
              
<svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C16.4183 0 20 3.58172 20 8C20 9.64785 19.5005 11.1785 18.6465 12.4512C21.7639 13.5434 24 16.5094 24 20V24C24 26.14 22.3194 27.8879 20.2061 27.9951L20 28H4C1.79086 28 0 26.2091 0 24V20C0 16.5097 2.23554 13.5437 5.35254 12.4512C4.4987 11.1786 4 9.64765 4 8C4 3.58172 7.58172 0 12 0ZM17.1572 14.1123C15.7644 15.2887 13.9659 16 12 16C10.0338 16 8.23472 15.289 6.8418 14.1123C4.08237 14.652 2 17.0825 2 20V24C2 25.1046 2.89543 26 4 26H20C21.1046 26 22 25.1046 22 24V20C22 17.0822 19.9171 14.6516 17.1572 14.1123ZM12 2C8.68629 2 6 4.68629 6 8C6 9.66133 6.67565 11.1645 7.7666 12.251C7.90462 12.3884 8.04939 12.519 8.2002 12.6426C9.23498 13.4905 10.5578 14 12 14C13.3314 14 14.5604 13.5648 15.5557 12.8311C15.8832 12.5895 16.1861 12.3164 16.458 12.0146C17.4162 10.9513 18 9.54404 18 8C18 4.68629 15.3137 2 12 2Z" fill="black"/>
</svg>

              {user?.first_name}
            </MenuItem>
            <MenuItem onClick={() => history.push("/account/myaccount")}>
              My Account
            </MenuItem>
            <MenuItem onClick={handlelogout}>Logout</MenuItem>
          </Menu>
        </>
      ) : isMobileOnly ? (
        <Button
          variant="link"
          className="rcs_before_login p-0"
          id="loginbutton"
          onClick={signin}
          aria-label="login"
        >
          {Theme === "newyork" || Theme === "showcase" ? (
           <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C16.4183 0 20 3.58172 20 8C20 9.64785 19.5005 11.1785 18.6465 12.4512C21.7639 13.5434 24 16.5094 24 20V24C24 26.14 22.3194 27.8879 20.2061 27.9951L20 28H4C1.79086 28 0 26.2091 0 24V20C0 16.5097 2.23554 13.5437 5.35254 12.4512C4.4987 11.1786 4 9.64765 4 8C4 3.58172 7.58172 0 12 0ZM17.1572 14.1123C15.7644 15.2887 13.9659 16 12 16C10.0338 16 8.23472 15.289 6.8418 14.1123C4.08237 14.652 2 17.0825 2 20V24C2 25.1046 2.89543 26 4 26H20C21.1046 26 22 25.1046 22 24V20C22 17.0822 19.9171 14.6516 17.1572 14.1123ZM12 2C8.68629 2 6 4.68629 6 8C6 9.66133 6.67565 11.1645 7.7666 12.251C7.90462 12.3884 8.04939 12.519 8.2002 12.6426C9.23498 13.4905 10.5578 14 12 14C13.3314 14 14.5604 13.5648 15.5557 12.8311C15.8832 12.5895 16.1861 12.3164 16.458 12.0146C17.4162 10.9513 18 9.54404 18 8C18 4.68629 15.3137 2 12 2Z" fill="black"/>
</svg>
            
          ) : props.Icon ? (
            <span className="rcs_mobile">
              {props.Icon} <br /> {props.Text}
            </span>
          ) : props.Img ? (
            <span className="rcs_mobile">
              
<svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C16.4183 0 20 3.58172 20 8C20 9.64785 19.5005 11.1785 18.6465 12.4512C21.7639 13.5434 24 16.5094 24 20V24C24 26.14 22.3194 27.8879 20.2061 27.9951L20 28H4C1.79086 28 0 26.2091 0 24V20C0 16.5097 2.23554 13.5437 5.35254 12.4512C4.4987 11.1786 4 9.64765 4 8C4 3.58172 7.58172 0 12 0ZM17.1572 14.1123C15.7644 15.2887 13.9659 16 12 16C10.0338 16 8.23472 15.289 6.8418 14.1123C4.08237 14.652 2 17.0825 2 20V24C2 25.1046 2.89543 26 4 26H20C21.1046 26 22 25.1046 22 24V20C22 17.0822 19.9171 14.6516 17.1572 14.1123ZM12 2C8.68629 2 6 4.68629 6 8C6 9.66133 6.67565 11.1645 7.7666 12.251C7.90462 12.3884 8.04939 12.519 8.2002 12.6426C9.23498 13.4905 10.5578 14 12 14C13.3314 14 14.5604 13.5648 15.5557 12.8311C15.8832 12.5895 16.1861 12.3164 16.458 12.0146C17.4162 10.9513 18 9.54404 18 8C18 4.68629 15.3137 2 12 2Z" fill="black"/>
</svg>

               {props.Text}
            </span>
          ) : ( 
<svg className="rcs_wishlist_icon" width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C16.4183 0 20 3.58172 20 8C20 9.64785 19.5005 11.1785 18.6465 12.4512C21.7639 13.5434 24 16.5094 24 20V24C24 26.14 22.3194 27.8879 20.2061 27.9951L20 28H4C1.79086 28 0 26.2091 0 24V20C0 16.5097 2.23554 13.5437 5.35254 12.4512C4.4987 11.1786 4 9.64765 4 8C4 3.58172 7.58172 0 12 0ZM17.1572 14.1123C15.7644 15.2887 13.9659 16 12 16C10.0338 16 8.23472 15.289 6.8418 14.1123C4.08237 14.652 2 17.0825 2 20V24C2 25.1046 2.89543 26 4 26H20C21.1046 26 22 25.1046 22 24V20C22 17.0822 19.9171 14.6516 17.1572 14.1123ZM12 2C8.68629 2 6 4.68629 6 8C6 9.66133 6.67565 11.1645 7.7666 12.251C7.90462 12.3884 8.04939 12.519 8.2002 12.6426C9.23498 13.4905 10.5578 14 12 14C13.3314 14 14.5604 13.5648 15.5557 12.8311C15.8832 12.5895 16.1861 12.3164 16.458 12.0146C17.4162 10.9513 18 9.54404 18 8C18 4.68629 15.3137 2 12 2Z" fill="black"/>
</svg>

          )}
        </Button>
      ) : (
        <span id="loginbutton" onClick={signin}>
          {Theme === "newyork" || Theme === "showcase" || Theme === "dubai" ? (
          
            <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C16.4183 0 20 3.58172 20 8C20 9.64785 19.5005 11.1785 18.6465 12.4512C21.7639 13.5434 24 16.5094 24 20V24C24 26.14 22.3194 27.8879 20.2061 27.9951L20 28H4C1.79086 28 0 26.2091 0 24V20C0 16.5097 2.23554 13.5437 5.35254 12.4512C4.4987 11.1786 4 9.64765 4 8C4 3.58172 7.58172 0 12 0ZM17.1572 14.1123C15.7644 15.2887 13.9659 16 12 16C10.0338 16 8.23472 15.289 6.8418 14.1123C4.08237 14.652 2 17.0825 2 20V24C2 25.1046 2.89543 26 4 26H20C21.1046 26 22 25.1046 22 24V20C22 17.0822 19.9171 14.6516 17.1572 14.1123ZM12 2C8.68629 2 6 4.68629 6 8C6 9.66133 6.67565 11.1645 7.7666 12.251C7.90462 12.3884 8.04939 12.519 8.2002 12.6426C9.23498 13.4905 10.5578 14 12 14C13.3314 14 14.5604 13.5648 15.5557 12.8311C15.8832 12.5895 16.1861 12.3164 16.458 12.0146C17.4162 10.9513 18 9.54404 18 8C18 4.68629 15.3137 2 12 2Z" fill="black"/>
</svg>
          ) : props.Icon ? (
            <span className="rcs_mobile">
              {props.Icon}
               <br /> {props.Text}
            </span>
          ) : props.Img ? (
            <span className="rcs_mobile">
              <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C16.4183 0 20 3.58172 20 8C20 9.64785 19.5005 11.1785 18.6465 12.4512C21.7639 13.5434 24 16.5094 24 20V24C24 26.14 22.3194 27.8879 20.2061 27.9951L20 28H4C1.79086 28 0 26.2091 0 24V20C0 16.5097 2.23554 13.5437 5.35254 12.4512C4.4987 11.1786 4 9.64765 4 8C4 3.58172 7.58172 0 12 0ZM17.1572 14.1123C15.7644 15.2887 13.9659 16 12 16C10.0338 16 8.23472 15.289 6.8418 14.1123C4.08237 14.652 2 17.0825 2 20V24C2 25.1046 2.89543 26 4 26H20C21.1046 26 22 25.1046 22 24V20C22 17.0822 19.9171 14.6516 17.1572 14.1123ZM12 2C8.68629 2 6 4.68629 6 8C6 9.66133 6.67565 11.1645 7.7666 12.251C7.90462 12.3884 8.04939 12.519 8.2002 12.6426C9.23498 13.4905 10.5578 14 12 14C13.3314 14 14.5604 13.5648 15.5557 12.8311C15.8832 12.5895 16.1861 12.3164 16.458 12.0146C17.4162 10.9513 18 9.54404 18 8C18 4.68629 15.3137 2 12 2Z" fill="black"/>
</svg>
               {props.Text}
            </span>
          ) : (
            <span>
       
                   <svg className="rcs_wishlist_icon" width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C16.4183 0 20 3.58172 20 8C20 9.64785 19.5005 11.1785 18.6465 12.4512C21.7639 13.5434 24 16.5094 24 20V24C24 26.14 22.3194 27.8879 20.2061 27.9951L20 28H4C1.79086 28 0 26.2091 0 24V20C0 16.5097 2.23554 13.5437 5.35254 12.4512C4.4987 11.1786 4 9.64765 4 8C4 3.58172 7.58172 0 12 0ZM17.1572 14.1123C15.7644 15.2887 13.9659 16 12 16C10.0338 16 8.23472 15.289 6.8418 14.1123C4.08237 14.652 2 17.0825 2 20V24C2 25.1046 2.89543 26 4 26H20C21.1046 26 22 25.1046 22 24V20C22 17.0822 19.9171 14.6516 17.1572 14.1123ZM12 2C8.68629 2 6 4.68629 6 8C6 9.66133 6.67565 11.1645 7.7666 12.251C7.90462 12.3884 8.04939 12.519 8.2002 12.6426C9.23498 13.4905 10.5578 14 12 14C13.3314 14 14.5604 13.5648 15.5557 12.8311C15.8832 12.5895 16.1861 12.3164 16.458 12.0146C17.4162 10.9513 18 9.54404 18 8C18 4.68629 15.3137 2 12 2Z" fill="black"/>
</svg>
              {Theme === "london" ? "Login" : null}
            </span>
          )}
        </span>
      )}
      <Modal
        className="rcs_login_modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={login}
        onHide={() => dispatch(loginDrawer(false))}
      >
        <Modal.Header>
          <button aria-label="Close"
            type="button"
            onClick={() => dispatch(loginDrawer(false))}
            className="close"
          >
            <span aria-hidden="true">×</span>
            <span className="sr-only">Close</span>
          </button>
        </Modal.Header>
        <Modal.Body>
          {forgotpassword ? (
            <div className="rcs_appointment_input rcs_login rcs_forgot">
              <Modal.Title id="contained-modal-title-vcenter">
                Forgot Password
              </Modal.Title>
              <div className="rcs_forgot_msg">
                <span>
                  To reset your password, please enter your email address
                </span>
              </div>
              <Form onSubmit={handleforgotpassword}>
                <Row>
                  <Col>
                    <TextField
                      id="outlined-basic"
                      label="Email Address"
                      type="Email"
                      variant="outlined"
                      value={f_email}
                      onChange={(e) => setF_email(e.target.value)}
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="rcs_fill_button"
                      type="submit"
                      disabled={buttonLoading}
                    >
                      Continue{" "}
                      {buttonLoading ? (
                        <CircularProgress className="rcs_loader" />
                      ) : (
                        ""
                      )}
                    </Button>
                  </Col>
                </Row>
                {errmsg2 ? (
                  <Row>
                    <Col>
                      <div className="rcs_signup_link rcs_signup_link_error">
                        <p style={{ color: "red" }}>{msg}</p>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                <Row>
                  <Col>
                    <div className="rcs_signup_link">
                      <p>
                        Remember your password ?
                        <NavLink
                          to="#"
                          onClick={() => setForgotpassword(false)}
                        >
                          Login
                        </NavLink>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          ) : (
            <div className="rcs_appointment_input rcs_login">
              <Modal.Title id="contained-modal-title-vcenter">
                Login
              </Modal.Title>
              <Form onSubmit={handlesubmitlogin}>
                <Row>
                  <Col>
                    <TextField
                      id="outlined-basic"
                      label="Email"
                      type="email"
                      variant="outlined"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <TextField
                      id="outlined-basic"
                      label="Password"
                      //type="password"
                      variant="outlined"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      type={viewPass ? "text" : "password"}
                    />
                    <span
                      className="passwordShowHide"
                      onClick={() => setViewPass(!viewPass)}
                    >
                      {viewPass ? <FiEye /> : <FiEyeOff />}{" "}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <NavLink
                      className="rcs_login_forgot rcs_forogt_pass"
                      to="#"
                      onClick={() => setForgotpassword(true)}
                    >
                      Forgot Password ?
                    </NavLink>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="rcs_fill_button"
                      type="submit"
                      disabled={buttonLoading}
                    >
                      Sign In
                      {buttonLoading ? (
                        <CircularProgress className="rcs_loader" />
                      ) : (
                        ""
                      )}
                    </Button>
                  </Col>
                </Row>
                {errmsg ? (
                  <Row>
                    <Col>
                      <div className="rcs_signup_link rcs_signup_link_error">
                        <p>{msg}</p>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                <Row>
                  <Col>
                    <div className="rcs_signup_link">
                      <p>
                        Don't have an account ?{" "}
                        <NavLink
                          to="/register"
                          onClick={() => dispatch(loginDrawer(false))}
                        >
                          Sign Up
                        </NavLink>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Form>
              <Row>
                <Col>
                  <div className="rcs_google_signup_main">
                    {/* <GoogleLogin
                                        clientId="549981789532-4bt0u9a45fujhv35ha0dil32bomr9221.apps.googleusercontent.com"
                                        buttonText="Sign in with Google"
                                        onSuccess={responseGoogle}
                                        onFailure={responseGoogle}
                                        cookiePolicy={'single_host_origin'}
                                    /> */}
                  </div>
                </Col>
              </Row>

              {/* <FacebookLogin
                        appId="1088597931155576"
                        autoLoad={false}
                        fields="name,email,picture"
                        callback={responseFacebook}
                        cssclassName="my-facebook-button-class"
                        icon="fa-facebook"
                        /> */}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Login;
